import { useRuntime } from './useRuntime';

export const useLocale = () => {
  const { locale, language, market } = useRuntime();

  return { locale, language, market };
};
